import React, { useRef, useEffect } from 'react';
import { useHistory } from 'react-router';
import { useEventListener } from './useEventListener'; // your generic event listener hook
import { useModalHandlers } from 'components/modal';
import { FmlxButton } from 'fmlx-common-ui';

export function useNavigationBlock(
  shouldBlock: (location?: string) => React.ReactNode | string | undefined,
) {
  const history = useHistory();
  const handlerRef = useRef(shouldBlock);
  const { showAwaitableModal, hideModal } = useModalHandlers();

  useEffect(() => {
    handlerRef.current = shouldBlock;
  }, [shouldBlock]);

  useEffect(() => {
    if (!history || typeof history.block !== 'function') {
      return;
    }

    const unblock = history.block((location) => {
      const msg = handlerRef.current(location);
      if (msg) {
        showAwaitableModal({
          heading: 'Confirm Navigation',
          body: msg,
          okButtonText: 'Leave',
          noButtonText: 'Stay',
          isModalEscapeable: false,
          hideCloseButton: true,
          customFooter: (
            <div className="flex flex-row items-center justify-end w-full h-12 gap-3 px-2 mt-4 border-t border-t-[#CACACA] border-solid border-0">
              <FmlxButton
                type="primary"
                variant="outline"
                onClick={() => {
                  hideModal();
                  unblock();
                  history.push(location.pathname);
                }}
                label="Leave"
              />
              <FmlxButton label="Stay" onClick={hideModal} />
            </div>
          ),
        });
        return false;
      }
      return true;
    });
    return () => unblock();
  }, [history, location.pathname]);

  useEventListener(
    'beforeunload',
    (event) => {
      const msg = handlerRef.current();
      if (!msg) {
        return;
      }
      event.preventDefault();
      event.returnValue = msg;
      return msg;
    },
    window,
  );
}
